import React, { useEffect, useState } from "react";
import { get } from "lodash";
import Slider from "react-slick";
import { Skeleton } from "@mui/material";
import axios from "axios";
import styles from "./News.module.scss";
import { API_URL, CONTENT_LIST, PRESS, KNOWLEDGECENTER, RELATED_CATEGORY_ARTICLES } from "../../routes/constants";
import { ReactComponent as IconChevronUp } from "../../assets/SVGs/chevron-up-white.svg";
import { ReactComponent as IconChevronDown } from "../../assets/SVGs/chevron-down-white.svg";
import { ReactComponent as DoubleArrows } from "../../assets/SVGs/arrows-two.svg";
import SASS from "../../sass/_exports.scss";
import { ArticleCard, ArtistCard } from "../../pages/ArticlePage/helper";
import { bounceIn, Button2 } from "../../components";
import { motion } from "motion/react"

const NewsV2 = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const subtitleDisplay = {
    ...(props.style || {}),
    display: props.subtitle ? "unset" : "none",
  };
  useEffect(() => {
    setLoading(true);
    const query = encodeURI(
      `${props.related !== undefined ? RELATED_CATEGORY_ARTICLES+"?id="+props.related+"&" : CONTENT_LIST+"?"}category=${props.category ? props.category : "all"}&limit=6&page=1&sort=-publishDate&type=${props.type ? props.type : "News"}`
    );
    const requestUrl = `${API_URL}${query}`;
    axios
      .get(requestUrl)
      .then((res) => {
        setLoading(false);
        if (get(res, "data.status")) {
          setData(get(res, "data.data.list", []));
          return true;
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, [props.type, props.category, props.related]);

  return (
    <motion.div className={`${styles.NewsContainer} ${props.className} ${props.artist ? styles.artist : ""} ${props.light ? styles.light : styles.dark}`} {...bounceIn}>
      {loading && (
        <Skeleton
          width="100%"
          height={300}
          animation="wave"
          className={styles.skeleton}
        />
      )}
      {!!get(data, "length") && !loading && (
        <div className={styles.subContainer}>
          <div className={styles.titleContainer}>
            <div className={`${styles.title}`}>
              <h3
                className={`${styles.heading} `}
                style={{ display: props.title ? "flex" : "none" }}
              >
                {props.title ? props.title : "beatBread News"}
              </h3>
              <h6 className={`${styles.subtitle}`} style={subtitleDisplay}>
                {props.subtitle}
              </h6>
            </div>
            <Button2 tertiary to={props.link ? props.link : props.type ? KNOWLEDGECENTER : PRESS} light={props.light ? true : false} dark={props.light ? false : true} className={styles.lnkBtnAll}>
              <p>{props.buttonTitle ? props.buttonTitle : "View All"}</p>
              <DoubleArrows />
            </Button2>
          </div>
          <div className={`${styles.carouselContainer}`}>
            
              {props.artist ? (
                <Slider
                  dots={true}
                  infinite={false}
                  slidesToShow={3}
                  slidesToScroll={3}
                  nextArrow={<IconChevronUp />}
                  prevArrow={<IconChevronDown />}
                  responsive={[
                    {
                      breakpoint: parseInt(SASS.SM_N),
                      settings: { slidesToShow: 1, slidesToScroll: 1 },
                    },
                    {
                      breakpoint: parseInt(SASS.LG_XL_N),
                      settings: { slidesToShow: 2, slidesToScroll: 2 },
                    },
                  ]}
                >
                  {data.map((content, i) => (
                    <ArtistCard key={i} light={props.light ? true : false} list={content} page={props.type ? KNOWLEDGECENTER : PRESS} marginTop />
                  ))}
                </Slider>
              ) : (
                <Slider
                  dots={true}
                  infinite={false}
                  slidesToShow={3}
                  slidesToScroll={3}
                  nextArrow={<IconChevronUp />}
                  prevArrow={<IconChevronDown />}
                  responsive={[
                    {
                      breakpoint: parseInt(SASS.SM_N),
                      settings: { slidesToShow: 1, slidesToScroll: 1 },
                    },
                    {
                      breakpoint: parseInt(SASS.LG_XL_N),
                      settings: { slidesToShow: 2, slidesToScroll: 2 },
                    },
                  ]}
                >
                  {data.map((content, i) => (
                    <ArticleCard key={i} light={props.light ? true : false} list={content} page={props.type ? KNOWLEDGECENTER : PRESS} marginTop />
                  ))}
                </Slider>
              )}
            
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default NewsV2;
